export default __webpack_public_path__ + "static/media/MessageActive.2eae6454.svg";